/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cascade_Dialog_Error_Boilers_GapInputs */



/**
* | output |
* | --- |
* | "The production groups must be consecutive and start with 1" |
*
* @param {Cascade_Dialog_Error_Boilers_GapInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const cascade_dialog_error_boilers_gap = /** @type {((inputs?: Cascade_Dialog_Error_Boilers_GapInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cascade_Dialog_Error_Boilers_GapInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The production groups must be consecutive and start with 1")
	return /** @type {LocalizedString} */ ("Les groupes de productions doivent être consécutifs et commencer par 1")
});